import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const isBrowser = typeof localStorage !== 'undefined';

/** Attaches X-Clinic-Id header from localStorage so the backend resolves the active clinic context. */
@Injectable()
export class HttpClinicContextInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isBrowser) return next.handle(req);
    const activeClinicId = localStorage.getItem('activeClinicId');
    if (!activeClinicId) return next.handle(req);
    const cloned = req.clone({ setHeaders: { 'X-Clinic-Id': activeClinicId } });
    return next.handle(cloned);
  }
}
